import reducers from './reducers';
import * as actionCreators from './actionCreators';
import * as selectors from './selectors';
import createInstanceForms from './formReducers';

export { actionCreators, selectors, createInstanceForms };

export default reducers;
